<!-- BEGIN: Left Aside -->
<button class="m-aside-left-close  m-aside-left-close--skin-dark" id="m_aside_left_close_btn" appunwraptag="">
	<i class="la la-close"></i>
</button>
<div id="m_aside_left" class="m-grid__item	m-aside-left  m-aside-left--skin-dark">
	<!-- BEGIN: Aside Menu -->
	<div  		id="m_ver_menu"  		class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark"  		data-menu-vertical="true" 		 data-menu-scrollable="false" data-menu-dropdown-timeout="500"   		>
		<ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow">
			<li class="m-menu__item  " routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
				<a [routerLink]="['/index']" class="m-menu__link">
					<i class="m-menu__link-icon flaticon-line-graph"></i>
					<span class="m-menu__link-title">
						<span class="m-menu__link-wrap">
							<span class="m-menu__link-text">
								Dashboard
							</span>
							<!--
							span class="m-menu__link-badge">
								<span class="m-badge m-badge--danger">
									2
								</span>
							</span>
							-->
						</span>
					</span>
				</a>
			</li>

			<!-- Reports -->
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Reports
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.analytics')">
				<a [routerLink]="['/report/incident']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-report"></i>
					<span class="m-menu__link-text">
						Incidents
					</span>
				</a>
			</li>

			<!-- Hierarchy -->
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Hierarchy
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.organizations.manage')">
				<a [routerLink]="['/organization']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-organization"></i>
					<span class="m-menu__link-text">
						Organizations
					</span>
				</a>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.organizations.manage')">
				<a [routerLink]="['/organization-group']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-role-group"></i>
					<span class="m-menu__link-text">
						Organization Groups
					</span>
				</a>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.permissions.manage')">
				<a [routerLink]="['/role-group']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-role-group"></i>
					<span class="m-menu__link-text">
						Role Groups
					</span>
				</a>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.users.manage')">
				<a [routerLink]="['/user']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-user"></i>
					<span class="m-menu__link-text">
						Users
					</span>
				</a>
			</li>

			<!-- Perimeters -->
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Perimeters
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>
			<!--
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
				<a [routerLink]="['/perimeter']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-perimeter"></i>
					<span class="m-menu__link-text">
						Perimeters
					</span>
				</a>
			</li>
			-->
			<!-- Campus -->
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.perimeters.manage')">
				<a [routerLink]="['/campus']" class="m-menu__link">
					<i class="m-menu__link-icon flaticon-map"></i>
					<span class="m-menu__link-text">
						Campuses
					</span>
				</a>
			</li>
			<!-- Buildings -->
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.perimeters.manage')">
				<a [routerLink]="['/building']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-building"></i>
					<span class="m-menu__link-text">
						Buildings
					</span>
				</a>
			</li>
			<!-- Floors -->
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.perimeters.manage')">
				<a [routerLink]="['/floor']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-floor"></i>
					<span class="m-menu__link-text">
						Floors
					</span>
				</a>
			</li>
			<!--
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon arcicon-floor"></i>
					<span class="m-menu__link-text">
						Floors
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Floors
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/floor']" class="m-menu__link">
								<i class="m-menu__link-icon flaticon-search"></i>
								<span class="m-menu__link-text">
									Find
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/floorplan']" class="m-menu__link">
								<i class="m-menu__link-icon arcicon-floorplan"></i>
								<span class="m-menu__link-text">
									Floorplans
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			-->
			<!-- Rooms -->
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.perimeters.manage')">
				<a [routerLink]="['/room']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-room"></i>
					<span class="m-menu__link-text">
						Rooms
					</span>
				</a>
			</li>
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.perimeters.manage')">
				<a [routerLink]="['/create-room-with-ai']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-room"></i>
					<span class="m-menu__link-text">
						Create Rooms With AI
					</span>
				</a>
			</li>

			<!-- Hardware -->
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Hardware
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.perimeters.manage')">
				<a [routerLink]="['/beacon-region']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-beacon-region"></i>
					<span class="m-menu__link-text">
						Regions
					</span>
				</a>
			</li>

			<!--
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.perimeters.manage')">
				<a [routerLink]="['/beacon']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-beacon"></i>
					<span class="m-menu__link-text">
						Beacons
					</span>
				</a>
			</li>
		-->

			<!-- Settings -->
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Settings
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.app.admin')">
				<a [routerLink]="['/application']" class="m-menu__link">
					<i class="m-menu__link-icon flaticon-chat-1"></i>
					<span class="m-menu__link-text">
						Application
					</span>
				</a>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.app.admin')">
				<a [routerLink]="['/sdk']" class="m-menu__link">
					<i class="m-menu__link-icon flaticon-chat-1"></i>
					<span class="m-menu__link-text">
						SDK
					</span>
				</a>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.organizations.manage')">
				<a [routerLink]="['/message-template']" class="m-menu__link">
					<i class="m-menu__link-icon flaticon-chat-1"></i>
					<span class="m-menu__link-text">
						Message Templates
					</span>
				</a>
			</li>

			<!--
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
				<a [routerLink]="['/incident-category']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-incident-category"></i>
					<span class="m-menu__link-text">
						Incident Categories
					</span>
				</a>
			</li>
		-->

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.sops.manage')">
				<a [routerLink]="['/incident-category']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-incident-category"></i>
					<span class="m-menu__link-text">
						Incident Categories
					</span>
				</a>
			</li>

			<!--
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
				<a [routerLink]="['/incident-category-alert-vendor']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-incident-category"></i>
					<span class="m-menu__link-text">
						Alert Vendors
					</span>
				</a>
			</li>
		-->

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.sops.manage')">
				<a [routerLink]="['/sop']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-incident-category"></i>
					<span class="m-menu__link-text">
						SOPs
					</span>
				</a>
			</li>

			<!-- Reports -->
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Pulse
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}" aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.app.admin')">
				<a [routerLink]="['/integration']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-report"></i>
					<span class="m-menu__link-text">
						Integrations
					</span>
				</a>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}" aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.app.admin')">
				<a [routerLink]="['/rule']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-report"></i>
					<span class="m-menu__link-text">
						Rules
					</span>
				</a>
			</li>

			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}" aria-haspopup="true" *ngIf="papi.isAuthorized('arcadmin.app.admin')">
				<a [routerLink]="['/action']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-report"></i>
					<span class="m-menu__link-text">
						Actions
					</span>
				</a>
			</li>

			<!-- Integrations -->
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Integrations
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>

			<!--
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
				<a [routerLink]="['/report/incident']" class="m-menu__link">
					<i class="m-menu__link-icon arcicon-beacon-region"></i>
					<span class="m-menu__link-text">
						Meridian
					</span>
				</a>
			</li>
			-->

			<li
			class="m-menu__item m-menu__item--submenu"
			[ngClass]="{ 'm-menu__item--open': isOpen || isChildRouteActive }"
			aria-haspopup="true"
			(click)="toggleMenu($event)"
			*ngIf="papi.isAuthorized('arcadmin.integrations.manage')"
		  >
			<a href="#" class="m-menu__link m-menu__toggle">
			  <i class="m-menu__link-icon arcicon-beacon-region"></i>
			  <span class="m-menu__link-text"> Meridian </span>
			  <i class="m-menu__ver-arrow la la-angle-right"></i>
			</a>
			<div class="m-menu__submenu">
			  <span class="m-menu__arrow"></span>
			  <ul class="m-menu__subnav">
				<li
				  class="m-menu__item m-menu__item--parent"
				  routerLinkActive="m-menu__item--active"
				  aria-haspopup="true"
				>
				  <span class="m-menu__link">
					<span class="m-menu__link-text"> Meridian </span>
				  </span>
				</li>
				<li
				  class="m-menu__item"
				  routerLinkActive="m-menu__item--active"
				  aria-haspopup="true"
				>
				  <a [routerLink]="['/meridian-location']" class="m-menu__link">
					<i class="m-menu__link-bullet m-menu__link-bullet--dot">
					  <span></span>
					</i>
					<span class="m-menu__link-text"> Locations </span>
				  </a>
				</li>
				<li
				  class="m-menu__item"
				  routerLinkActive="m-menu__item--active"
				  aria-haspopup="true"
				>
				  <a [routerLink]="['/meridian-map']" class="m-menu__link">
					<i class="m-menu__link-bullet m-menu__link-bullet--dot">
					  <span></span>
					</i>
					<span class="m-menu__link-text"> Maps </span>
				  </a>
				</li>
			  </ul>
			</div>
		  </li>
		  
		  


			<!-- DEMO -->
			<!--
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Angular
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>
			<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
				<a [routerLink]="['/angular/ng-bootstrap']" class="m-menu__link">
					<i class="m-menu__link-icon flaticon-settings"></i>
					<span class="m-menu__link-text">
						Ng-Bootstrap
					</span>
				</a>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-settings"></i>
					<span class="m-menu__link-text">
						PrimeNG
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									PrimeNG
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/angular/primeng/input']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Input
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/angular/primeng/button']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Button
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/angular/primeng/panel']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Panel
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Components
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-layers"></i>
					<span class="m-menu__link-text">
						Base
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Base
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/state']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									State Colors
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/typography']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Typography
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/stack']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Stack
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/tables']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Tables
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/progress']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Progress
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/modal']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Modal
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/alerts']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Alerts
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/popover']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Popover
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/tooltip']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Tooltip
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/blockui']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Block UI
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/spinners']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Spinners
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/scrollable']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Scrollable
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/dropdown']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Dropdown
								</span>
							</a>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Tabs
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/base/tabs/bootstrap']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Bootstrap Tabs
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/base/tabs/line']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Line Tabs
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/accordions']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Accordions
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/navs']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Navs
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/lists']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Lists
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/treeview']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Tree View
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/bootstrap-notify']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Bootstrap Notify
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/toastr']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Toastr
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/base/sweetalert2']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									SweetAlert2
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-share"></i>
					<span class="m-menu__link-text">
						Icons
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/icons/flaticon']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Flaticon
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/icons/fontawesome']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Fontawesome
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/icons/lineawesome']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Lineawesome
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/icons/socicons']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Socicons
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-multimedia-1"></i>
					<span class="m-menu__link-text">
						Buttons
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Buttons
								</span>
							</span>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Button Base
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/buttons/base/default']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Default Style
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/buttons/base/square']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Square Style
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/buttons/base/pill']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Pill Style
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/buttons/base/air']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Air Style
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/buttons/group']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Button Group
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/buttons/dropdown']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Button Dropdown
								</span>
							</a>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Button Icon
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/buttons/icon/lineawesome']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Lineawesome Icons
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/buttons/icon/fontawesome']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Fontawesome Icons
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/buttons/icon/flaticon']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Flaticon Icons
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-interface-7"></i>
					<span class="m-menu__link-text">
						Forms
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Forms
								</span>
							</span>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Form Controls
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/controls/base']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Base Inputs
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/controls/checkbox-radio']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Checkbox & Radio
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/controls/input-group']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Input Groups
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/controls/switch']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Switch
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/controls/option']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Mega Options
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Form Widgets
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-datepicker']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Datepicker
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-datetimepicker']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Datetimepicker
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-timepicker']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Timepicker
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-daterangepicker']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Daterangepicker
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-touchspin']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Touchspin
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-maxlength']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Maxlength
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-switch']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Switch
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-multipleselectsplitter']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Multiple Select Splitter
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-select']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Bootstrap Select
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/select2']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Select2
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/typeahead']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Typeahead
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/nouislider']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												noUiSlider
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/form-repeater']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Repeater
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/ion-range-slider']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Ion Range Slider
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/input-mask']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Input Masks
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/summernote']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Summernote WYSIWYG
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/bootstrap-markdown']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Markdown Editor
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/autosize']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Autosize
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/clipboard']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Clipboard
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/dropzone']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Dropzone
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/widgets/recaptcha']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Google reCaptcha
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Form Layouts
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/layouts/default-forms']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Default Forms
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/layouts/multi-column-forms']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Multi Column Forms
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/layouts/action-bars']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Action Bars
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Form Validation
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/validation/states']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Validation States
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/validation/form-controls']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Controls
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/validation/form-widgets']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Widgets
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Form Wizard
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/wizard/wizard-1']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Wizard 1
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/wizard/wizard-2']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Wizard 2
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/wizard/wizard-3']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Wizard 3
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/wizard/wizard-4']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Wizard 4
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/forms/wizard/wizard-5']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Form Wizard 5
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-tabs"></i>
					<span class="m-menu__link-text">
						Datatables
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Datatables
								</span>
							</span>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Base
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/data-local']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Local Data
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/data-json']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												JSON Data
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/data-ajax']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Ajax Data
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/html-table']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												HTML Table
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/record-selection']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Record Selection
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/local-sort']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Local Sort
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/row-details']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Row Details
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/column-rendering']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Column Rendering
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/column-width']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Column Width
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/responsive-columns']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Responsive Columns
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/base/translation']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Translation
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Scrolling
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/scrolling/vertical']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Vertical Scrolling
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/scrolling/horizontal']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Horizontal Scrolling
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/scrolling/both']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Both Scrolling
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Locked Columns
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/locked/left']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Left Locked Columns
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/locked/right']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Right Locked Columns
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/locked/both']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Both Locked Columns
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/locked/html-table']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												HTML Table
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Child Datatables
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/child/data-local']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Local Data
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/child/data-ajax']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Remote Data
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									API
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/api/methods']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												API Methods
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/datatables/api/events']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Events
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-interface-1"></i>
					<span class="m-menu__link-text">
						Portlets
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Portlets
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/portlets/base']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Base Portlets
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/portlets/advanced']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Advanced Portlets
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/portlets/creative']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Creative Portlets
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/portlets/tabbed']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Tabbed Portlets
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/portlets/draggable']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Draggable Portlets
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/portlets/tools']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Portlet Tools
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-interface-6"></i>
					<span class="m-menu__link-text">
						Timeline
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Timeline
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/timeline/timeline-1']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Timeline 1
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/timeline/timeline-2']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Timeline 2
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-network"></i>
					<span class="m-menu__link-text">
						Widgets
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Widgets
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/widgets/general']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									General Widgets
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/widgets/chart']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Chart Widgets
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-calendar"></i>
					<span class="m-menu__link-text">
						Calendar
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Calendar
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/calendar/basic']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Basic Calendar
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/calendar/list-view']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									List Views
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/calendar/google']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Google Calendar
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/calendar/external-events']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									External Events
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/calendar/background-events']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Background Events
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-diagram"></i>
					<span class="m-menu__link-text">
						Charts
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Charts
								</span>
							</span>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									amCharts
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/charts/amcharts/charts']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												amCharts Charts
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/charts/amcharts/stock-charts']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												amCharts Stock Charts
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/components/charts/amcharts/maps']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												amCharts Maps
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/charts/flotcharts']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Flot Charts
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/charts/google-charts']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Google Charts
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/charts/morris-charts']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Morris Charts
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-placeholder-1"></i>
					<span class="m-menu__link-text">
						Maps
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Maps
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/maps/google-maps']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Google Maps
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/maps/jqvmap']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									JQVMap
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-signs-2"></i>
					<span class="m-menu__link-text">
						Utils
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Utils
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/utils/session-timeout']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Session Timeout
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/components/utils/idle-timer']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Idle Timer
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__section">
				<h4 class="m-menu__section-text">
					Snippets
				</h4>
				<i class="m-menu__section-icon flaticon-more-v3"></i>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-interface-9"></i>
					<span class="m-menu__link-text">
						Pricing Tables
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Pricing Tables
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/snippets/general/pricing-tables/pricing-table-1']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Pricing Tables v1
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/snippets/general/pricing-tables/pricing-table-2']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Pricing Tables v2
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/snippets/general/pricing-tables/pricing-table-3']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Pricing Tables v3
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/snippets/general/pricing-tables/pricing-table-4']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Pricing Tables v4
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-piggy-bank"></i>
					<span class="m-menu__link-text">
						Invoices
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Invoices
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/snippets/invoices/invoice-1']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Invoice v1
								</span>
							</a>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/snippets/invoices/invoice-2']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Invoice v2
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-exclamation"></i>
					<span class="m-menu__link-text">
						FAQS
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									FAQS
								</span>
							</span>
						</li>
						<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<a [routerLink]="['/snippets/faq/faq-1']" class="m-menu__link">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									FAQ v1
								</span>
							</a>
						</li>
					</ul>
				</div>
			</li>
			<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
				<a  href="#" class="m-menu__link m-menu__toggle">
					<i class="m-menu__link-icon flaticon-suitcase"></i>
					<span class="m-menu__link-text">
						Custom Pages
					</span>
					<i class="m-menu__ver-arrow la la-angle-right"></i>
				</a>
				<div class="m-menu__submenu">
					<span class="m-menu__arrow"></span>
					<ul class="m-menu__subnav">
						<li class="m-menu__item  m-menu__item--parent" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
							<span class="m-menu__link">
								<span class="m-menu__link-text">
									Custom Pages
								</span>
							</span>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									User Pages
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/user/login-1']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Login - 1
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/user/login-2']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Login - 2
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/user/login-3']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Login - 3
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/user/login-4']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Login - 4
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/user/login-5']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Login - 5
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
						<li class="m-menu__item  m-menu__item--submenu" routerLinkActive="m-menu__item--open" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true"  data-menu-submenu-toggle="hover">
							<a  href="#" class="m-menu__link m-menu__toggle">
								<i class="m-menu__link-bullet m-menu__link-bullet--dot">
									<span></span>
								</i>
								<span class="m-menu__link-text">
									Error Pages
								</span>
								<i class="m-menu__ver-arrow la la-angle-right"></i>
							</a>
							<div class="m-menu__submenu">
								<span class="m-menu__arrow"></span>
								<ul class="m-menu__subnav">
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/errors/error-1']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Error 1
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/errors/error-2']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Error 2
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/errors/error-3']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Error 3
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/errors/error-4']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Error 4
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/errors/error-5']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Error 5
											</span>
										</a>
									</li>
									<li class="m-menu__item" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{exact: true}"  aria-haspopup="true" >
										<a [routerLink]="['/snippets/pages/errors/error-6']" class="m-menu__link">
											<i class="m-menu__link-bullet m-menu__link-bullet--dot">
												<span></span>
											</i>
											<span class="m-menu__link-text">
												Error 6
											</span>
										</a>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</li>
			-->
		</ul>
	</div>
	<!-- END: Aside Menu -->
</div>
<!-- END: Left Aside -->
